import { EventTypes } from 'redux-segment';
import { handleError } from 'Shared/helpers';
import * as api from 'Shared/api';

export const CHART_FILTER_CHANGE = 'CHART_FILTER_CHANGE';
export function userClickedFilter(chart, data) {
  return {
    type: CHART_FILTER_CHANGE,
    chart,
    data,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: `CHART_FILTER_CHANGE for ${chart}`,
          properties: { data },
        },
      },
    },
  };
}

export const getTimeseries =
  (metric_code, metrics, timeFilters = {}) =>
  (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: 'REQUEST_METRIC_TIMESERIES_RESOURCE',
      metric_code,
    });

    return api.getSeries({ metric_code, metrics, timeFilters, jwt_token: state.user.jwt_token }).then(
      response => {
        const json = response.data;

        dispatch({
          type: 'RECEIVE_METRIC_TIMESERIES_RESOURCE',
          metric_code,
          data: json.data,
        });
      },
      error => {
        dispatch(handleError(error));
      }
    );
  };
